import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import withAuthLayout from "../../hoc/withAuthLayout";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link } from "react-router-dom";
import EmailIcon from "../../assets/email.svg";
import PasswordIcon from "../../assets/password.svg";
import PasswordHide from "../../assets/password-hide.svg";
import PasswordShow from "../../assets/password-show.svg";
import { loginValidation } from "../../utils/validations/formValidations";
import AuthContainer from "../../components/ui/AuthContainer";
import { LoginAdmin } from "../../utils/api";
import { message } from "antd";
import { setInLocalStorage } from "../../utils/storageUtil";

const Login = () => {
  const navigate = useNavigate();
  const [passwordVisible, setIsPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(loginValidation) });

  const onSubmit = async (data) => {
    const loginData = {
      email: data.email,
      password: data.password,
    };

    try {
      setLoading(true);
      const resData = await LoginAdmin(loginData);
      if (resData?.isSuccess) {
        message.destroy();
        message.success("Admin Logged In Successfully");
        setInLocalStorage("admin", resData?.data?.user);
        navigate("/admin/dashboard");
        setLoading(false);
      } else {
        message.destroy();
        message.error("Invalid credentials");
        setLoading(false);
      }
    } catch (error) {
      console.error("Login error:", error);
      message.error("An error occurred during login. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthContainer>
      <h2 className="font-bold text-base heading">Log In</h2>
      <h4 className="2xl:text-base font-semibold text-xs">Welcome back!</h4>
      <p className="text-[12px] 2xl:text-base text-input-placeholder">
        Please enter your email and password to sign in
      </p>
      <form
        className="flex flex-col "
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <div className="2xl:p-4 border border-input-placeholder border-[#000E2F70] flex items-center gap-x-2 rounded-xl p-3 relative mt-2">
          <label
            className="2xl:text-sm absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1"
            htmlFor="email"
          >
            Email
          </label>
          <img src={EmailIcon} alt="email-svg" width={12} />
          <input
            placeholder="michellejohnson125@gmail.com"
            className="w-full outline-none text-[12px] text-input-placeholder"
            type="email"
            id="email"
            {...register("email")}
          />
        </div>
        <p className="text-[red] text-[12px]">{errors.email?.message}</p>
        <div className="2xl:p-4 border border-input-placeholder border-[#000E2F70] flex gap-x-2 rounded-xl p-3 relative mt-4">
          <label
            className="2xl:text-sm absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1"
            htmlFor="password"
          >
            Password
          </label>
          <img src={PasswordIcon} alt="password-svg" width={12} />
          <input
            placeholder="********"
            className="w-full outline-none text-[12px] text-input-placeholder"
            type={passwordVisible ? "text" : "password"}
            id="password"
            {...register("password")}
          />
          <img
            src={passwordVisible ? PasswordHide : PasswordShow}
            alt="password-hide"
            width={12}
            className="cursor-pointer"
            onClick={() => setIsPasswordVisible(!passwordVisible)}
          />
        </div>
        <p className="text-[red] text-[12px]">{errors.password?.message}</p>
        <Link
          className="text-[11px] my-2 mr-2 text-input-placeholder w-max ml-auto"
          to="/auth/forgot-password"
        >
          Forgot Password ?
        </Link>
        <button
          type="submit"
          disabled={loading}
          className="sign-in text-center mt-6 bg-[#E5B3B2] w-max mx-auto text-white text-[10px] px-12 py-3 rounded-lg flex items-center gap-x-2"
        >
          <span>Sign In</span>
          {loading && <span className="loader"></span>}
        </button>
      </form>
    </AuthContainer>
  );
};

export default withAuthLayout(Login);
